import {
  getFailed,
  getStarted,
  getSucceeded,
  getEnded,
  statusEnum,
  PROFILE_DEFAULT,
  PROFILE_GET_USER_AND_SUBUSERS,
  PROFILE_SUBMIT,
  PROFILE_EDIT_SELECTED,
  PROFILE_UPDATE_SUBMIT,
  SUB_USER_CREATE_SUBMIT,
  SUB_USER_DELETE_SUBMIT,
  CHANGE_PASSWORD_SUBMIT,
  PROFILE_LIST_RESET,
  ON_CHANGE_PROFILE_FORM,
  PROFILE_OPTION_SELECTED,
  PROFILE_LANGUAGE_SELECTED,
  SUB_USER_GRADUATE,
  IS_UNSAVED,
  USER_DELETE_SUBMIT,
  CLEAR_PROMPT,
} from "../actions/constant";
import {
  getMonthFromDate,
  getYearFromDate,
} from "../components/componentsConstant";
import { logout } from "../services/AuthenticationService";
import i18n from "../i18n";
import Validations from "../components/Validations";

const initialState = {
  isLoading: false,
  status: statusEnum.DEFAULT,
  actionResponse: null,
  user: null,
  nameExist: false,
  mainUser: null,
  subUsers: null,
  isEditing: false,
  allUsers: [],
  selectedIndex: -1,
  amountReseter: false,
  firstChange: false,
  subUserCreateForm: { allergen: [], selectedLanguage: "", ethnicity: [] },
  saveSuccessUpdate: false,
  gradSuccess: false,
  // fieldChange: false,
  selectedProfile: {},
  disabled: {
    addBtn: true,
    clearBtn: true,
    gradBtn: true,
  },
  emailError: false,
  wrongPassError: false,
  profileNotUpdated: false,
  counterState: 0,
  languageUpdated: false,
  isUpdating: false,
  checkPassword: false,
};

const isValidNumber = (value) => {
  // return /^(\d+(\.\d+)?|\.\d+)$/.test(value);
  return /^(\d+(\.\d+)?|\.\d+)$/.test(value) && parseFloat(value) > 0;
};

const isPasswordFullyValid = (password) => {
  return (
    !Validations.min8(password) &&
    !Validations.max15(password) &&
    !Validations.min_one_uppercase(password) &&
    !Validations.min_one_lowercase(password) &&
    !Validations.min_one_number(password) &&
    !Validations.min_one_special(password)
  );
};

function disableCheckerProfilePage(state) {
  let languageUpdated = localStorage.getItem("languageUpdate");
  let disabled = {
    addBtn: true,
    clearBtn: true,
  };
  let vAlertMessages = {
    title: i18n.t("profile.UNSAVED_PROFILE_CHANGE_TITLE"),
    text: i18n.t("profile.UNSAVED_PROFILE_CHANGE_TEXT"),
    page: "profile",
  };
  const isArraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;

    // Sort both arrays and compare
    const sortedArr1 = arr1.slice().sort();
    const sortedArr2 = arr2.slice().sort();

    return sortedArr1.every((value, index) => value === sortedArr2[index]);
  };

  let isAllergenSame = true;
  let isEthnicitySame = true;
  const { selectedProfile, subUserCreateForm } = state;
  if (
    selectedProfile &&
    selectedProfile.allergen_name &&
    subUserCreateForm.allergen_name
  ) {
    isAllergenSame = isArraysEqual(
      selectedProfile.allergen_name,
      subUserCreateForm.allergen_name
    );
    isEthnicitySame = isArraysEqual(
      selectedProfile.ethnicity_name,
      subUserCreateForm.ethnicity_name
    );
  }

  disabled.addBtn = !(
    state.subUserCreateForm.first_name &&
    state.subUserCreateForm.last_name &&
    state.subUserCreateForm.birthMonth &&
    state.subUserCreateForm.birthMonth !== "null" &&
    state.subUserCreateForm.birthYear &&
    state.subUserCreateForm.birthYear !== "null" &&
    state.subUserCreateForm.gender &&
    state.subUserCreateForm.gender !== "null" &&
    state.subUserCreateForm.group &&
    state.subUserCreateForm.group !== "null" &&
    state.subUserCreateForm.height &&
    isValidNumber(state.subUserCreateForm.height) &&
    isValidNumber(state.subUserCreateForm.weight) &&
    state.firstChange === true &&
    isAllergenSame !== undefined &&
    isAllergenSame
  );

  if (
    state.subUserCreateForm.first_name ||
    state.subUserCreateForm.last_name ||
    (state.subUserCreateForm.birthMonth &&
      state.subUserCreateForm.birthMonth != "null") ||
    (state.subUserCreateForm.birthYear &&
      state.subUserCreateForm.birthYear != "null") ||
    (state.subUserCreateForm.gender &&
      state.subUserCreateForm.gender != "null") ||
    (state.subUserCreateForm.group &&
      state.subUserCreateForm.group != "null") ||
    isValidNumber(state.subUserCreateForm.height) ||
    isValidNumber(state.subUserCreateForm.weight) ||
    (state.subUserCreateForm.lang && state.subUserCreateForm.lang != "null") ||
    (state.subUserCreateForm.allergen &&
      state.subUserCreateForm.allergen.length > 0) ||
    (state.subUserCreateForm.ethnicity &&
      state.subUserCreateForm.ethnicity.length > 0)
  ) {
    // localStorage.removeItem("unsavedAlertData");
    // IS_UNSAVED("no");
    disabled.clearBtn = false;
  }
  if (disabled.clearBtn) {
    localStorage.removeItem("logoutWithoutUpdateProfile");
    localStorage.removeItem("logoutWithoutSaveProfile");
    localStorage.removeItem("unsavedAlertData");
    IS_UNSAVED("no");
  }
  if (disabled.addBtn) {
    IS_UNSAVED("no");
    state.profileNotUpdated = false;
  }

  if (
    state.subUserCreateForm.first_name ||
    state.subUserCreateForm.last_name ||
    (state.subUserCreateForm.birthMonth &&
      state.subUserCreateForm.birthMonth != "null") ||
    (state.subUserCreateForm.birthYear &&
      state.subUserCreateForm.birthYear != "null") ||
    (state.subUserCreateForm.gender &&
      state.subUserCreateForm.gender != "null") ||
    (state.subUserCreateForm.group &&
      state.subUserCreateForm.group != "null") ||
    (state.subUserCreateForm.ethnicity &&
      state.subUserCreateForm.ethnicity != "null") ||
    isValidNumber(state.subUserCreateForm.height) ||
    isValidNumber(state.subUserCreateForm.weight) ||
    (state.subUserCreateForm.lang && state.subUserCreateForm.lang != "null") ||
    state.subUserCreateForm.allergen_name.length
  ) {

    let isSubUserSelected = state.subUsers.some((f) => f.isSelected);
    if (
      state.firstChange == true &&
      (state.mainUser.isSelected || isSubUserSelected) &&
      state.isEditing
    ) {

      localStorage.setItem("unsavedAlertData", JSON.stringify(vAlertMessages));

      IS_UNSAVED("yes");
    } else if (
      state.firstChange == true &&
      !state.mainUser.isSelected &&
      !isSubUserSelected &&
      (state.subUserCreateForm.first_name ||
        state.subUserCreateForm.last_name ||
        state.subUserCreateForm.birthMonth ||
        state.subUserCreateForm.birthYear ||
        state.subUserCreateForm.gender ||
        state.subUserCreateForm.group ||
        (state.subUserCreateForm.ethnicity &&
          state.subUserCreateForm.ethnicity.length > 0) ||
        (state.subUserCreateForm.allergen &&
          state.subUserCreateForm.allergen.length > 0) ||
        isValidNumber(state.subUserCreateForm.height) ||
        isValidNumber(state.subUserCreateForm.weight) ||
        (state.subUserCreateForm.lang &&
          state.subUserCreateForm.lang !== "null"))
    ) {

      vAlertMessages = {
        title: i18n.t("profile.UNSAVED_NEW_PROFILE_TITLE_2"),
        text: i18n.t("profile.UNSAVED_NEW_SUBUSER_TEXT"),
        page: "profile",
        isNew: true,
      };
      localStorage.setItem("unsavedAlertData", JSON.stringify(vAlertMessages));
      IS_UNSAVED("yes");
    }
  } else if (
    !state.subUserCreateForm.first_name &&
    !state.subUserCreateForm.last_name &&
    !state.subUserCreateForm.birthMonth &&
    !state.subUserCreateForm.birthYear &&
    !state.subUserCreateForm.gender &&
    !state.subUserCreateForm.group &&
    state.subUserCreateForm.ethnicity &&
    !state.subUserCreateForm.ethnicity.length &&
    state.subUserCreateForm.allergen &&
    !state.subUserCreateForm.allergen.length &&
    !isValidNumber(state.subUserCreateForm.height) &&
    !isValidNumber(state.subUserCreateForm.weight) &&
    !state.subUserCreateForm.lang
  ) {

    IS_UNSAVED("no");
  }

  if (state.selectedProfile && state.isEditing && state.selectedIndex != -1) {
    if (state.mainUser.isSelected) {
      if (
        state.subUserCreateForm.old_password.length > 0 ||
        state.subUserCreateForm.new_password.length > 0 ||
        state.subUserCreateForm.confirm_password.length > 0
      ) {
        const newPass = state.subUserCreateForm.new_password;
        const confirmPass = state.subUserCreateForm.confirm_password;

        if (
          state.subUserCreateForm.old_password &&
          isPasswordFullyValid(newPass) &&
          newPass === confirmPass &&
          state.subUserCreateForm.lang &&
          state.subUserCreateForm.lang !== "null"
        ) {
          IS_UNSAVED("yes");
          state.profileNotUpdated = true;
          state.checkPassword = true;
        } else {
          state.checkPassword = false;
          disabled.addBtn = true;
          IS_UNSAVED("no");
        }
        IS_UNSAVED("yes");
        state.profileNotUpdated = true;
      } else {

        state.checkPassword = false;
        if (
          state.subUserCreateForm.first_name !=
          state.selectedProfile.first_name ||
          state.subUserCreateForm.last_name !=
          state.selectedProfile.last_name ||
          state.subUserCreateForm.birthMonth !=
          state.selectedProfile.birthMonth ||
          state.subUserCreateForm.birthYear !=
          state.selectedProfile.birthYear ||
          state.subUserCreateForm.group != state.selectedProfile.group ||
          state.subUserCreateForm.gender != state.selectedProfile.gender ||
          state.subUserCreateForm.weight != state.selectedProfile.weight ||
          state.subUserCreateForm.height != state.selectedProfile.height ||
          state.subUserCreateForm.lang != state.selectedProfile.lang ||
          !isAllergenSame ||
          !isEthnicitySame
        ) {
          state.profileNotUpdated = true;
          if (
            state.subUserCreateForm.first_name &&
            state.subUserCreateForm.last_name &&
            state.subUserCreateForm.birthMonth &&
            state.subUserCreateForm.birthMonth !== "null" &&
            state.subUserCreateForm.birthYear &&
            state.subUserCreateForm.birthYear !== "null" &&
            state.subUserCreateForm.gender &&
            state.subUserCreateForm.gender !== "null" &&
            state.subUserCreateForm.group &&
            state.subUserCreateForm.group !== "null" &&
            state.subUserCreateForm.lang !== "null" &&
            isValidNumber(state.subUserCreateForm.height) &&
            isValidNumber(state.subUserCreateForm.weight)
          ) {
            disabled.addBtn = false;
          } else {
            disabled.addBtn = true;
            IS_UNSAVED("yes");
          }
          disabled.gradBtn = true;
        } else {
          IS_UNSAVED("no");
          state.profileNotUpdated = false;
          disabled.addBtn = true;
          disabled.gradBtn = false;
        }
      }
    } else {
      state.checkPassword = false;

      if (
        state.subUserCreateForm.first_name !=
        state.selectedProfile.first_name ||
        state.subUserCreateForm.last_name != state.selectedProfile.last_name ||
        state.subUserCreateForm.birthMonth !=
        state.selectedProfile.birthMonth ||
        state.subUserCreateForm.birthYear != state.selectedProfile.birthYear ||
        state.subUserCreateForm.group != state.selectedProfile.group ||
        state.subUserCreateForm.gender != state.selectedProfile.gender ||
        state.subUserCreateForm.weight != state.selectedProfile.weight ||
        state.subUserCreateForm.height != state.selectedProfile.height ||
        state.subUserCreateForm.lang != state.selectedProfile.lang ||
        !isAllergenSame ||
        !isEthnicitySame
      ) {
        state.profileNotUpdated = true;
        if (
          state.subUserCreateForm.first_name &&
          state.subUserCreateForm.last_name &&
          state.subUserCreateForm.birthMonth &&
          state.subUserCreateForm.birthMonth !== "null" &&
          state.subUserCreateForm.birthYear &&
          state.subUserCreateForm.birthYear !== "null" &&
          state.subUserCreateForm.gender &&
          state.subUserCreateForm.gender !== "null" &&
          state.subUserCreateForm.group &&
          state.subUserCreateForm.group !== "null" &&
          state.subUserCreateForm.lang !== "null" &&
          isValidNumber(state.subUserCreateForm.height) &&
          isValidNumber(state.subUserCreateForm.weight)
        ) {
          disabled.addBtn = false;
        } else {
          disabled.addBtn = true;
          // IS_UNSAVED("no");
        }
        disabled.gradBtn = true;
      } else {
        IS_UNSAVED("no");
        state.profileNotUpdated = false;
        disabled.addBtn = true;
        disabled.gradBtn = false;
      }
    }
  } else {
    state.checkPassword = false;
  }

  return disabled;
}
function allergenOut(object, arg) {
  let outPut = [];
  if (object && object.length > 0) {
    object.map((item) => {
      if (arg === "fullname") {
        outPut.push(" " + item[arg]);
      } else {
        outPut.push(item[arg]);
      }
    });
  }
  return outPut;
}
function ethnicityOut(object, arg) {
  let outPut = [];
  if (object && object.length > 0) {
    object.map((item) => {
      if (arg === "name") {
        outPut.push(" " + item[arg]);
      } else {
        outPut.push(item[arg]);
      }
    });
  }
  return outPut;
}
// Profile reducer
function reducer(state = initialState, action) {
  let allUsers = [];
  let selectedIndex = -1;
  let isEditing = false;
  switch (action.type) {
    case PROFILE_DEFAULT:
      return initialState;
    case getStarted(PROFILE_GET_USER_AND_SUBUSERS):
      return {
        ...state,
        isLoading: true,
      };
    case getSucceeded(PROFILE_GET_USER_AND_SUBUSERS):
      let languageUpdated = localStorage.getItem("languageUpdate");
      if (languageUpdated) {
        state.languageUpdated = true;
        localStorage.removeItem("languageUpdate");
      } else {
        state.languageUpdated = false;
      }
      const mainuser = {
        ...action.payload,
        birthYear: action.payload.birthday.year,
        birthMonth: action.payload.birthday.month,
        ethnicity: action.payload.ethnicity,
        ethnicity_name: ethnicityOut(action.payload.ethnicity, "name"),
        allergen_name: allergenOut(action.payload.allergen, "fullname"),
        old_password: "",
        new_password: "",
        confirm_password: "",
      };
      let user = mainuser;
      var subUsers = [];
      if (action.payload.sub_users !== undefined) {
        subUsers =
          action.payload.sub_users &&
          action.payload.sub_users.map((value) => {
            return {
              ...value,
              birthYear: value.birthday.year,
              birthMonth: value.birthday.month,
              // ethnicity_id: value.ethnicity ? value.ethnicity._id : "",
              // ethnicity: value.ethnicity ? value.ethnicity.name : "",
              ethnicity: value.ethnicity,
              ethnicity_name: ethnicityOut(value.ethnicity, "name"),
              allergen_name: allergenOut(value.allergen, "fullname"),
              //address_id: value.address._id,
              //address: value.address.name,
            };
          });
      }

      return {
        ...state,
        // user: user,
        mainUser: mainuser,
        subUsers: subUsers,
        allUsers: [user, ...subUsers],
        subUserCreateForm: {
          allergen: [],
          allergen_name: [],
        },
        selectedIndex: -1,
        languageUpdated: false,
      };
    case getSucceeded(PROFILE_SUBMIT):
      return { ...state, status: statusEnum.SUCCESS };
    case getFailed(PROFILE_GET_USER_AND_SUBUSERS):
      return { ...state, actionResponse: action.payload };
    case getEnded(PROFILE_GET_USER_AND_SUBUSERS):
      return { ...state, isLoading: false };
    case PROFILE_EDIT_SELECTED:
      selectedIndex = action.index;

      if (state.selectedIndex !== -1) {
        profileSelected = {};
        isEditing = false;
        state.subUserCreateForm = {};
        state.profileNotUpdated = false;
      }
      allUsers = [...state.allUsers];
      let profileSelected = { ...allUsers[selectedIndex] };
      if (profileSelected.allergen) {
        profileSelected.allergen_name = allergenOut(
          profileSelected.allergen,
          "fullname"
        );
      }

      for (const profile of allUsers) {
        profile.isSelected = false;
      }
      allUsers[selectedIndex].isSelected = true;
      isEditing = true;

      state.subUserCreateForm = { ...profileSelected };
      state.firstChange = false;
      if (selectedIndex === state.selectedIndex) {
        profileSelected = {};
        allUsers[selectedIndex].isSelected = false;
        selectedIndex = -1;
        state.selectedIndex = -1;
        isEditing = false;
        state.subUserCreateForm = {};
        state.subUserCreateForm.height = "";
        state.subUserCreateForm.weight = "";
        state.subUserCreateForm.allergen_name = [];
        state.subUserCreateForm.ethnicity_name = [];
      } else if (
        selectedIndex > -1 &&
        !state.subUserCreateForm.height &&
        !state.subUserCreateForm.weight
      ) {
        state.subUserCreateForm.height = "";
        state.subUserCreateForm.weight = "";
      }
      //state.subUserCreateForm.allergen_name = [];
      state.selectedProfile = state.allUsers[selectedIndex];
      state.amountReseter = !state.amountReseter;
      return {
        ...state,
        allUsers: allUsers,
        isEditing,
        selectedIndex: selectedIndex,
        // subUserCreateForm: { ...profileSelected },
        disabled: disableCheckerProfilePage(state),
      };
    case getStarted(PROFILE_UPDATE_SUBMIT):
      action.payload[0].allergen = allergenOut(
        action.payload[0].allergen,
        "_id"
      );
      state.isLoading = true;

      return {
        ...state,
        isUpdating: true,
        isLoading: true,
        nameExist: false,
        wrongPassError: false,
        saveSuccessUpdate: false,
      };
    case getSucceeded(PROFILE_UPDATE_SUBMIT):
      var users = state.allUsers;
      var changedIndex = null;
      users.forEach((element, index) => {
        if (element._id === action.payload[0]._id) {
          changedIndex = index;
        }
      });

      const updateduser = {
        ...action.payload[0],
        birthYear: action.payload[0].birthday.year,
        birthMonth: action.payload[0].birthday.month,
        ethnicity:
          action.payload[0].group === "1100" ? action.payload[0].ethnicity : [],
        group: action.payload[0].group,
        lang: action.payload[0].lang,
        allergen: action.payload[0].allergen,
        weight: action.payload[0].weight,
        height: action.payload[0].height,
      };
      updateduser.isSelected = true;
      users[changedIndex] = updateduser;
      var changeCounter = state.changeCounter ? state.changeCounter + 1 : 1;
      // setTimeout(() => {
      //   window.location.reload();
      // }, 2000);

      IS_UNSAVED("no");
      if (
        state.subUserCreateForm.selectedLanguage &&
        state.subUserCreateForm.selectedLanguage != "null"
      ) {
        state.languageUpdated = true;
        localStorage.setItem("languageUpdate", true);
      }
      return {
        ...state,
        statusPU: statusEnum.SUCCESS,
        allUsers: users,
        // isLoading: false,
        changeCounter: changeCounter,
        // saveSuccess: true,
        saveSuccessUpdate: true,
        wrongPassError: false,
      };
    case getFailed(PROFILE_UPDATE_SUBMIT):
      if (action.payload.message === "username_already_exist") {
        state.nameExist = true;
      } else {
        // alert(action.payload.message);
        state.wrongPassError = true;
      }
      return { ...state, isLoading: false, isUpdating: false };
    case getEnded(PROFILE_UPDATE_SUBMIT):
      state.languageUpdated = false;
      return {
        ...state,

        isLoading: false,
        isUpdating: false,
        statusPU: undefined,
      };
    case getStarted(SUB_USER_CREATE_SUBMIT):
      return {
        ...state,
        isUpdating: true,
        saveSuccess: false,
        nameExist: false,
        isLoading: true,
      };
    case getSucceeded(SUB_USER_CREATE_SUBMIT):
      if (action.payload._id) {
        const newduser = {
          ...action.payload,
          birthYear: action.payload.birthday.year,
          birthMonth: action.payload.birthday.month,
          ethnicity: action.payload.ethnicity || [],
          group: action.payload.group,
          //allergen: action.payload.allergen,
          weight: action.payload.weight,
          height: action.payload.height,
        };
        var users = [...state.allUsers, newduser];
        var changeCounter = state.changeCounter ? state.changeCounter + 1 : 1;

        IS_UNSAVED("no");
        return {
          ...state,
          status: statusEnum.SUCCESS,
          allUsers: users,
          changeCounter: changeCounter,
          saveSuccess: true,
          isLoading: false,
          isUpdating: false,
        };
      }
    case getFailed(SUB_USER_CREATE_SUBMIT):
      if (action.payload.message === "username_already_exist") {
        state.nameExist = true;
      } else {
        alert(action.payload.message);
      }
      return {
        ...state,
        actionResponse: action.payload,
        status: statusEnum.ERROR,
        isLoading: false,
        isUpdating: false,
      };
    case getEnded(SUB_USER_CREATE_SUBMIT):
    case getStarted(SUB_USER_DELETE_SUBMIT):
      return { ...state };
    case getSucceeded(SUB_USER_DELETE_SUBMIT):
      if (action.payload.deletedId) {
        var users = state.allUsers;
        var changedIndex = null;
        users.forEach((element, index) => {
          if (element._id === action.payload.deletedId) {
            changedIndex = index;
          }
        });
        users.splice(changedIndex, 1);
        state.selectedIndex = -1;
        state.allUsers.forEach((user) => {
          user.isSelected = false;
        });
        var changeCounter = state.changeCounter ? state.changeCounter + 1 : 1;
        state.disabled.clearBtn = true;
        state.disabled.addBtn = true;
        IS_UNSAVED("no");

        return {
          ...state,
          status: statusEnum.SUCCESS,
          allUsers: users,
          isLoading: false,
          changeCounter: changeCounter,
          isEditing: false,
          profileNotUpdated: false,
          subUserCreateForm: {
            height: "",
            weight: "",
            ethnicity_name: [],
            allergen_name: [],
          },
          selectedProfile: {},
        };
      }
    case getFailed(SUB_USER_DELETE_SUBMIT):
      return {
        ...state,
        actionResponse: action.payload,
        status: statusEnum.ERROR,
      };
    case getEnded(SUB_USER_DELETE_SUBMIT):
      state.subUserCreateForm.weight = state.subUserCreateForm.weight;
      state.subUserCreateForm.height = state.subUserCreateForm.height;
      state.amountReseter = !state.amountReseter;
      var changeCounter = state.changeCounter ? state.changeCounter + 1 : 1;
      return {
        ...state,
        changeCounter: changeCounter,
      };
    case getSucceeded(USER_DELETE_SUBMIT):
      logout();
      window.location.href = "/";
      return state;
    case getFailed(USER_DELETE_SUBMIT):
      return {
        ...state,
        actionResponse: action.payload,
        status: statusEnum.ERROR,
      };
    case getStarted(CHANGE_PASSWORD_SUBMIT):
      return { ...state, isLoading: true };
    case getSucceeded(CHANGE_PASSWORD_SUBMIT):
      return { ...state, statusCHP: statusEnum.SUCCESS };
    case getFailed(CHANGE_PASSWORD_SUBMIT):
      return {
        ...state,
        actionResponseCHP: action.payload,
        statusCHP: statusEnum.ERROR,
      };
    case getEnded(CHANGE_PASSWORD_SUBMIT):
      return {
        ...state,
        isLoading: true,
        actionResponseCHP: undefined,
        statusCHP: undefined,
      };
    case PROFILE_LIST_RESET:
      allUsers = [...state.allUsers];
      state.subUserCreateForm = {};
      for (const profile of allUsers) {
        profile.isSelected = false;
      }
      selectedIndex = -1;
      isEditing = false;
      state.subUserCreateForm.weight = "";
      state.subUserCreateForm.height = "";
      state.subUserCreateForm.allergen_name = [];
      state.subUserCreateForm.ethnicity_name = [];
      state.languageUpdated = false;
      state.amountReseter = !state.amountReseter;
      state.firstChange = false;
      state.profileNotUpdated = false;
      state.selectedProfile = {};

      return {
        ...state,
        disabled: disableCheckerProfilePage(state),
        allUsers,
        selectedIndex,
        isEditing,
        profileNotUpdated: false,
      };
    case ON_CHANGE_PROFILE_FORM:
      let newAllergen = {};
      let allergenList = [];
      let newEthnicity = {};
      let ethnicityList = [];
      if (action.event.target.name == "allergen") {
        newAllergen = action.event.target.value;
        allergenList = state.subUserCreateForm.allergen
          ? [...state.subUserCreateForm.allergen]
          : [];
        newAllergen = {
          _id: newAllergen._id,
          name: newAllergen.name,
          fullname: newAllergen.fullname,
        };
        allergenList.push(newAllergen);
        state.subUserCreateForm.allergen = allergenList;
        state.subUserCreateForm.allergen_name = allergenOut(
          allergenList,
          "fullname"
        );
      } else if (action.event.target.name == "allergenDelete") {
        newAllergen = action.event.target.value;
        allergenList = [...state.subUserCreateForm.allergen];
        var index = allergenList.indexOf(newAllergen);
        if (index !== -1) {
          allergenList.splice(index, 1);
        }
        //allergenList.pop(newAllergen);
        state.subUserCreateForm.allergen = allergenList;
        state.subUserCreateForm.allergen_name = allergenOut(
          allergenList,
          "fullname"
        );
      } else if (action.event.target.name == "ethnicity") {
        newEthnicity = action.event.target.value;
        ethnicityList = state.subUserCreateForm.ethnicity
          ? [...state.subUserCreateForm.ethnicity]
          : [];
        newEthnicity = {
          _id: newEthnicity._id,
          name: newEthnicity.name,
        };
        ethnicityList.push(newEthnicity);
        state.subUserCreateForm.ethnicity = ethnicityList;
        state.subUserCreateForm.ethnicity_name = ethnicityOut(
          ethnicityList,
          "name"
        );
      } else if (action.event.target.name == "ethnicityDelete") {
        newEthnicity = action.event.target.value;
        ethnicityList = [...state.subUserCreateForm.ethnicity];
        var index = ethnicityList.indexOf(newEthnicity);
        if (index !== -1) {
          ethnicityList.splice(index, 1);
        }
        state.subUserCreateForm.ethnicity = ethnicityList;
        state.subUserCreateForm.ethnicity_name = ethnicityOut(
          ethnicityList,
          "name"
        );
      } else {
        state.subUserCreateForm[action.event.target.name] =
          action.event.target.value;
      }

      if (action.event.target.name == "height") {
        state.subUserCreateForm.height = action.event.target.value.replace(
          /[A-z\s&=/+,?`~";-_]+/g,
          ""
        );
      } else if (action.event.target.name == "weight") {
        state.subUserCreateForm.weight = action.event.target.value.replace(
          /[A-z\s&=/+,?`~";-_]+/g,
          ""
        );
      }

      if (action.event.target.name == "group") {
        state.subUserCreateForm.ethnicity = [];
        state.subUserCreateForm.ethnicity_name = [];
      }

      state.firstChange = true;
      state.stateChanger = !state.stateChanger;
      return {
        ...state,
        disabled: disableCheckerProfilePage(state),
        counterState: state.counterState + 1,
      };
    case PROFILE_OPTION_SELECTED:
      var currentForm = { ...state.subUserCreateForm };

      disableCheckerProfilePage(state);
      return {
        ...state,
        subUserCreateForm: currentForm,
        disabled: disableCheckerProfilePage(state),
        amountReseter: !state.amountReseter,
        counterState: state.counterState + 1,
      };
    case PROFILE_LANGUAGE_SELECTED:
      if (action.language.length > 0) {
        state.subUserCreateForm.selectedLanguage = action.language[0].code;
        state.subUserCreateForm.lang = action.language[0].value;
      } else {
        state.subUserCreateForm.selectedLanguage = null;
        state.subUserCreateForm.lang = "null";
      }
      state.firstChange = true;
      return {
        ...state,
        disabled: disableCheckerProfilePage(state),
        counterState: state.counterState + 1,
      };

    case getEnded(PROFILE_OPTION_SELECTED):
      return {
        ...state,
        disabled: disableCheckerProfilePage(state),
        counterState: state.counterState + 1,
      };
    case CLEAR_PROMPT:
      return {
        ...state,
        saveSuccess: false,
        gradSuccess: false,
      };
    case getStarted(SUB_USER_GRADUATE):
      return {
        ...state,
        isLoading: true,
        gradSuccess: false,
        emailError: false,
      };
    case getSucceeded(SUB_USER_GRADUATE):
      return { ...state, gradSuccess: true };
    case getFailed(SUB_USER_GRADUATE):
      return { ...state, isLoading: false, emailError: true };
    case getEnded(SUB_USER_GRADUATE):
      return { ...state, isLoading: false };
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/profileReducer.js